import {useQuery} from '@apollo/react-hooks';
import type {FetchPolicy} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {GetSetting as GetSettingQuery} from 'nutshell-graphql-types';

import GET_SETTING from './graphql/queries/get-setting.graphql';

export const useGetSetting = (input: {
    settingName: string;
    isGlobal?: boolean;
    fetchPolicy?: FetchPolicy;
}) => {
    const {
        loading: isLoading,
        data,
        networkStatus,
        error,
        refetch,
    } = useQuery<GetSettingQuery, Record<any, any>>(GET_SETTING, {
        variables: {...input},
        fetchPolicy: input.fetchPolicy || 'cache-and-network',
    });

    const setting = data ? data.setting : null;

    return {
        isLoading,
        isFirstLoad: isFirstLoad(networkStatus),
        setting,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
